import { render, staticRenderFns } from "./AddonDialog.vue?vue&type=template&id=03465c88"
import script from "./AddonDialog.vue?vue&type=script&lang=js"
export * from "./AddonDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('03465c88')) {
      api.createRecord('03465c88', component.options)
    } else {
      api.reload('03465c88', component.options)
    }
    module.hot.accept("./AddonDialog.vue?vue&type=template&id=03465c88", function () {
      api.rerender('03465c88', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/package_student/components/dialog/AddonDialog.vue"
export default component.exports